<template>
  <vx-card class="mt-2 pagebreak-inside-avoid">
    <table class="table">
      <tr class="title p-1 w-full">
        <th colspan="4">ENDEREÇO DO SEGURADO</th>
      </tr>
      <tr>
        <td class="pl-3">
          <b>CEP</b>:
          {{
            proposalData.dadosCliente.cep ? proposalData.dadosCliente.cep : ''
          }}
        </td>
        <td class="pl-3">
          <b>Endereço</b>:
          {{
            proposalData.dadosCliente.endereco
              ? proposalData.dadosCliente.endereco
              : ''
          }}
        </td>
        <td class="pl-3">
          <b>Número</b>:
          {{
            proposalData.dadosCliente.numero
              ? proposalData.dadosCliente.numero
              : ''
          }}
        </td>
      </tr>
      <tr>
        <td class="pl-3">
          <b>Complemento</b>:
          {{
            proposalData.dadosCliente.complemento
              ? proposalData.dadosCliente.complemento
              : ''
          }}
        </td>
        <td class="pl-3">
          <b>Bairro</b>:
          {{
            proposalData.dadosCliente.bairro
              ? proposalData.dadosCliente.bairro
              : ''
          }}
        </td>
        <td class="pl-3">
          <b>Cidade</b>:
          {{
            proposalData.dadosCliente.cidade
              ? proposalData.dadosCliente.cidade
              : ''
          }}
        </td>
        <td class="pl-3">
          <b>Estado</b>:
          {{
            proposalData.dadosCliente.estado
              ? proposalData.dadosCliente.estado
              : ''
          }}
        </td>
      </tr>
    </table>
    <div
      v-if="customSectionsMsgs.INSURED_ADDRESS"
      style="text-align: justify"
      class="pl-3 pt-3"
      v-html="customSectionsMsgs.INSURED_ADDRESS"
    ></div>
  </vx-card>
</template>

<script>
export default {
  name: 'EndorsementContractInsuredAddress',
  props: {
    proposalData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    customSectionsMsgs: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
};
</script>
